import styled from '@emotion/styled';

import theme from '@/styles/theme';

export const Root = styled.div`
  position: relative;
  width: 100%;
  max-width: 900px;
  margin: 0 auto 24px;
  padding: 20px 24px;
  background: ${theme.palette.common.white};
  border-radius: ${theme.shape.borderRadiusLarge}px;
  box-shadow: ${theme.boxShadow.elevation1};

  ${theme.breakpoints.down('md')} {
    max-width: 100%;
    padding: 16px;
  }
`;
